import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class StepService {
  constructor() {}

  private width = new BehaviorSubject<string>('0%');
  private showRiepilogo = new BehaviorSubject<boolean>(false);
  private showRingraziamenti = new BehaviorSubject<boolean>(false);
  static currentQuestion = 0;
  static totalQuestion = 0;

  setWidth(width: string) {
    this.width.next(width);
  }

  getWidth() {
    return this.width.asObservable();
  }

  setShowRiepilogo(showRiepilogo: boolean) {
    this.showRiepilogo.next(showRiepilogo);
  }

  getShowRiepilogo() {
    return this.showRiepilogo.asObservable();
  }

  setShowRingraziamenti(value: boolean) {
    this.showRingraziamenti.next(value);
  }

  getShowRingraziamenti() {
    return this.showRingraziamenti.asObservable();
  }
}
